import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Ticket, TicketQuery } from '@fgb/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { fgbAnimations } from '@fgb/portal-component-library/src/lib/shared/animations';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-ticket-transfer-select-bar',
  standalone: true,
  imports: [CommonModule, FGBSharedModule, RouterModule],
  templateUrl: './ticket-transfer-select-bar.component.html',
  styleUrl: './ticket-transfer-select-bar.component.scss',
  animations: [
    // Import animations
    fgbAnimations
  ]
})
export class TicketTransferSelectBar{
  selectedTickets$: Observable<number>;
  isOpen$: Observable<boolean>;
  gameNumber: string | null;

  constructor(private ticketsQuery: TicketQuery, private route: ActivatedRoute) {}

  ngOnInit() {
    this.gameNumber = this.route.snapshot.paramMap.get('gameNumber');
    this.selectedTickets$ = this.ticketsQuery.selectedTickets().pipe(
      map((tickets: Ticket[]) => tickets?.length || 0)
    );
    // Open the bar if selected tickets are greater than 0 and perform the slideUpAnimation
    this.isOpen$ = this.selectedTickets$.pipe(map((selectedTickets) => selectedTickets > 0));
  }
}
